<template>
  <div class="patient-container rounded-lg">
    <h5 class="text-left mt-2 mb-2 pl-3">Patients</h5>
    <div class="form-group position-relative search-container pl-3 pr-3">
      <input
        type="text"
        class="form-control search-input"
        v-model="searchText"
      />
      <i class="fa fa-search search-icon"></i>
    </div>
    <div class="patients-list  pl-0 pr-0" :style="{ maxHeight: shouldScroll ? '320px' : 'auto' }">
      <div
        v-for="patient in filteredPatients"
        :key="patient.id"
        class="media user-item px-0"
        :class="{ 'selected-user': patient.id === selectedUserId }"
        @click="selectUser(patient)"
      >
        <div class="media user-item px-0" :class="{ 'selected-user': patient.id === selectedUserId }">
  <div class="avatar mr-3 d-flex pl-3">
    <img :src="patient.profilePic" alt="user-profile-picture" class="avatar-40 rounded" />
  </div>
  <div class="d-flex flex-column text-left pr-3 user-info">
    <h6 class="mb-0">{{ patient.firstName }} {{ patient.lastName }}</h6>
    <span class="user-email">{{ patient.email }}</span>
  </div>
</div>

      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, watchEffect } from 'vue'

export default {
  props: {
    patientsList: {
      type: Array,
      required: true
    }
  },
  setup (props, context) {
    const searchText = ref('')
    const selectedUserId = ref(null)
    const shouldScroll = ref(false)

    const filteredPatients = computed(() =>
      props.patientsList.filter((patient) =>
        (patient.firstName + ' ' + patient.lastName)
          .toLowerCase()
          .includes(searchText.value.toLowerCase())
      )
    )

    watchEffect(() => {
      shouldScroll.value = filteredPatients.value.length > 0
    })

    const selectUser = (patient) => {
      selectedUserId.value = patient.id
      context.emit('userClickedCharts', patient)
    }

    return {
      searchText,
      filteredPatients,
      selectedUserId,
      selectUser,
      shouldScroll
    }
  }
}
</script>

<style scoped>
.patient-container {
  background-color: white;
  font-size: 0.8rem;
  border-radius: 15px;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
}

.patients-list {
  overflow-y: auto;
  overflow-x:hidden;
}

.search-input {
  height: 30px;
}

.search-icon {
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
}

.user-item {
  cursor: pointer;
  color: grey;
  background-color: var(--container);
  align-items: center;
  padding: 5px 0;
}

.user-item.selected-user {
  color: var(--muted-text-color);
  background-color: var(--light-grey);
}

.text-left {
  text-align: left;
}

.separator {
  border-top: 1px dotted lightgrey;
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-email {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

</style>
